/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { InsertEnrollmentDocumentOfCourseViewModel } from "../types/InsertEnrollmentDocumentOfCourseViewModel.ts";

export const insertEnrollmentDocumentOfCourseViewModelSchema = z.object({
  courseId: z.optional(
    z
      .number()
      .int()
      .describe("ID do curso ao qual o documento de matrícula será vinculado."),
  ),
  enrollmentDocumentId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do tipo de documento de matrícula a ser associado ao curso.",
      ),
  ),
}) as unknown as ToZod<InsertEnrollmentDocumentOfCourseViewModel>;
